export default class EventEmitter<T extends string | symbol> {
  private listeners: Map<T, Function[]>;

  constructor() {
    this.listeners = new Map();
  }

  on(event: T, listener: Function) {
    const eventListeners = this.listeners.get(event) || [];
    eventListeners.push(listener);
    this.listeners.set(event, eventListeners);
  }

  emit(event: T, ...args: any[]) {
    const eventListeners = this.listeners.get(event);
    if (eventListeners) {
      for (const listener of eventListeners) {
        listener(...args);
      }
    }
  }
}
